import { Button } from "@website/ui/button";
import { Loading } from "@website/ui/loading";
import styles from "@website/ui/toggle-button/toggle-button.module.scss";
import { ToggleButtonPropertiesType } from "@website/ui/toggle-button/toggle-button.types";
import omit from "lodash-es/omit";
import { FC, memo } from "react";

const ToggleButton: FC<ToggleButtonPropertiesType> = (properties) => {
  const {
    className,
    color = "primary",
    disabled,
    loading,
    size = "medium",
    variant = "contained",
    list,
    value,
    onChange,
    lineDirection = "horizontal",
    rounded = false
  } = properties;

  return (
    <div
      className={`${styles["container"]} ${styles[lineDirection]} ${
        rounded ? styles["rounded"] : ""
      } ${className ?? ""}`}
    >
      {loading ? (
        <Loading color="white" size="sm" />
      ) : (
        <>
          {list.map((item) => (
            <Button
              {...omit(
                item,
                "id",
                "disabled",
                "color",
                "loading",
                "size",
                "variant",
                "fullWidth"
              )}
              className={styles["btn-class-name"]}
              color={item.value === value ? color : "neutral"}
              disabled={disabled}
              key={item.value}
              onClick={() => onChange?.(item?.value || "")}
              replace={item?.replace}
              size={size}
              variant={item.value === value ? variant : "text"}
            />
          ))}
        </>
      )}
    </div>
  );
};

const ToggleButtonMemoized = memo(ToggleButton);
export { ToggleButtonMemoized as ToggleButton };
